import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { toggleModal } from 'store/ui/actions'
import { setMode } from 'store/login-modal/actions'
import classNames from 'classnames'
import Header from 'components/typography/Header'
import styles from './styles/Plan.css'
import themeStyles from './styles/PlanTheme.css'
import Button from 'components/forms/Button'
import * as analytics from 'lib/analytics'
import { useHistory } from 'react-router-dom'
import { FeatureCopy } from 'components/pricing/Features'
import Card from 'components/layout/Card'
import planConfig from '../../../config/static/pricing-plans'
import { planIsAtLeast } from 'lib/user'

const VALID_PLANS = Object.keys(planConfig)

export const ctaCopy = (plan, user, defaultCTA) => {
  if (plan === 'integrate' || plan === 'data' || plan === 'organization' || plan === 'group') {
    return defaultCTA
  }

  if (!user?.subscription?.plan) {
    return 'Activate two week trial'
  }

  if (user?.subscription?.customerID && plan !== 'free' && plan === user?.subscription?.plan && user?.subscription?.status !== 'trialing' && user?.subscription?.status !== 'inactive') {
    return 'Manage your plan'
  }

  if (user?.subscription?.status === 'trialing' || user?.subscription?.status === 'inactive') {
    return defaultCTA
  }

  if (plan === 'basic' && planIsAtLeast(user?.subscription?.plan, 'premium')) {
    return 'Downgrade'
  }

  if (plan === 'premium' && planIsAtLeast(user?.subscription?.plan, 'premium_plus')) {
    return 'Downgrade'
  }

  return defaultCTA
}

const Plan = ({ plan, handleSeeMore, className }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const fetchingUser = useSelector(({ ui }) => ui.fetchingUser)
  const user = useSelector(({ ui }) => ui.user)
  const planData = planConfig[plan] || {}
  const disableCta = plan !== 'free' && plan === user?.subscription?.plan && user?.subscription?.status !== 'trialing'

  const registerPlan = plan => {
    history.push('/pricing')
    analytics.event({
      category: 'User',
      action: 'Register Plan',
      label: plan
    })
  }

  const handleClick = () => {
    if (!user?.subscription?.plan && planData.stripePlan) {
      dispatch(setMode('register'))
      dispatch(toggleModal('login'))
    } else if (planData.stripePlan) {
      registerPlan(plan)
    } else if (plan === 'integrate') {
      analytics.event({
        category: 'User',
        action: 'Integration Contact Us'
      })
      window.open('mailto:sales@scite.ai')
    } else if (plan === 'data') {
      analytics.event({
        category: 'User',
        action: 'Data Contact Us'
      })
      window.open(`${CONFIG.sciteFrontendURL}/data-and-services`)
    } else if (plan === 'organization') {
      analytics.event({
        category: 'User',
        action: 'Requested Organization Free Trial',
        label: plan
      })
      window.open(CONFIG.trialFormURL)
    } else if (plan === 'group') {
      analytics.event({
        category: 'User',
        action: 'Requested Group Quote',
        label: plan
      })
      window.open(CONFIG.quoteFormURL)
    }
  }

  return (
    <Card className={classNames(styles.plan, themeStyles[plan], className)}>
      {planData.ribbon &&
        <img loading='lazy' alt='ribbon' className={styles.ribbon} src={`${CONFIG.assetsBaseURL}/images/pricing/${planData.ribbon}.svg?v=2`} />}

      <div className={styles.iconContainer}>
        <img alt='plan-illustration' className={styles.icon} src={`${CONFIG.assetsBaseURL}/images/pricing/${planData.illustration}.svg`} />
      </div>

      <Header className={styles.header} level={2}>
        {planData.name}
      </Header>

      {planData.price >= 0 && (
        <div className={styles.pricing}>
          <Header level={2} className={styles.price}>${planData.price}</Header>
        </div>
      )}

      <div className={styles.subheading}>
        {planData.subheading}
      </div>
      {planData.usecase && (
        <div className={styles.usecase}>
          {planData.usecase}
        </div>
      )}
      {!fetchingUser && (
        <div className={styles.ctaContainer}>
          <Button
            className={styles.cta}
            color='blue'
            disabled={disableCta}
            onClick={handleClick}
          >
            {
              ctaCopy(
                plan,
                user,
                planData.CTA
              )
            }
          </Button>
        </div>
      )}
      <FeatureCopy plan={plan} />
      <div className={styles.seeMore} onClick={handleSeeMore}>
        {planData.stripePlan ? 'Compare All Features' : 'See How scite Can Help'}
      </div>
    </Card>
  )
}

Plan.propTypes = {
  plan: PropTypes.oneOf(VALID_PLANS).isRequired,
  handleSeeMore: PropTypes.func
}

export default Plan
